import React from 'react';

import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Button } from '../../atoms/Button';

const useStyles = makeStyles((theme: Theme) => ({
  action: { fontSize: theme.typography.pxToRem(13) },
  button: {
    minWidth: 0,
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
  },

  root: {
    background: theme.palette.grey[200],
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
    padding: theme.spacing(1.5, 1.875, 1.875, 1.875),
  },
  title: { fontSize: theme.typography.pxToRem(12) },
  topSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
}));

export type Props = {
  action?: () => void;
  actionText?: string;
  dataFd?: string;
  listItems: JSX.Element[];
  listName?: string;
  title?: string;
};

export const HorizontalList = (props: Props): JSX.Element => {
  const {
    action,
    actionText,
    dataFd = 'horizontal-list',
    listItems,
    listName,
    title,
  } = props;
  const classes = useStyles();
  const rootStyle = clsx(
    'fd-horizontal-list',
    listName && `fd-horizontal-list__${listName.toLowerCase()}`,
    classes.root,
  );

  const showActionButton = action && actionText;
  const showTopSection = title || showActionButton;

  return (
    <div className={rootStyle} data-fd={dataFd}>
      {showTopSection && (
        <div className={classes.topSection}>
          {title && (
            <Typography
              className={classes.title}
              data-fd="horizontal-list-title"
            >
              {title}
            </Typography>
          )}
          {showActionButton && (
            <Button className={classes.button} onClick={action} variant="text">
              <Typography className={classes.action}>{actionText}</Typography>
            </Button>
          )}
        </div>
      )}
      {!!listItems.length && (
        <div className={classes.list} data-fd="horizontal-list-list">
          {listItems}
        </div>
      )}
    </div>
  );
};
